export function isWellBehavedNumber(n) {
  return Number.isFinite(n);
}